import * as actionTypes from "./actionTypes";

export const getGroups = (week, year) => {
    return {
        type: actionTypes.GET_GROUPS,
        week: week,
        year: year
    };
};

export const getGroupsSucceeded = (groups, week, year) => ({
    type: actionTypes.GET_GROUPS_SUCCEEDED,
    groups,
    week,
    year
});

export const selectGroup = (groupID) => ({
    type: actionTypes.SELECT_GROUP,
    groupID
});

export const setDateFilter = (neededDate, daysFilterApplied = true) => ({
    type: actionTypes.SET_DATE_FILTER,
    neededDate,
    daysFilterApplied,
});
